module.exports = __webpack_public_path__ + "img/1_020.78206300.jpg";